import React from 'react';
import AdminKitchenClosedown from '../admin-kitchen-closedown';
const JKHiveKitchenClosedown = () => <AdminKitchenClosedown />;
export default JKHiveKitchenClosedown;
